// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__6XbB5","modal":"Modal_modal__XTESB","show-modal":"Modal_show-modal__boDXj","slide-down":"Modal_slide-down__jf0s5"};